import { observable } from 'mobx';
import { persist } from 'mobx-persist';
import { ISpinnerSettings } from '../../interface/spinner-settings.interface';
import { BlockColorType } from '../../enum/block-color.enum';

export class SpinnerModel implements ISpinnerSettings {
  @persist @observable spinnerColor: BlockColorType;
  @persist @observable spinner: number;
}
